<template>
  <!--使用elementui的table如下,速度较慢-->
  <div>
    <div class="el-table__body-wrapper" v-show="false"></div>
    <div v-if="isShowTotalNumber" style="text-align:right;font-size:12px;"><span
      v-if="isshowprice&&price['单价']!=undefined">单价：{{price['单价']}}</span>&nbsp;<span>总数：{{totalnumber}}</span>&nbsp;<span
      v-if="isshowprice&&price['总价']!=undefined">总价：{{price['总价']}}</span></div>
    <el-table
      :data="erweitable" v-if="!userHtml"
      :height="geterwtableHeight()" border :header-cell-class-name="'twodimensionalcellheader'"
      :cell-class-name="cellClassName"
      size="mini"
      style="width: 100%;">
      <el-table-column
        width="48"
        label="球\柱"
        align="center">
        <template slot-scope="scope">
          {{(qiujing[scope.$index] > 0 ? "+" : "" ) + qiujing[scope.$index].toFixed(2)}}
        </template>
      </el-table-column>
      <el-table-column v-for="(item,xindex) in zhujing" :key="item"
                       :label="(item > 0 ? '+' : '')+item.toFixed(2)"
                       align="right" :width="tdwidth" header-align="center">
        <template slot-scope="scope">
          <span v-if="showtopcolor"
                :style="{backgroundColor:getTopInfoColor(scope.row[xindex].P,topInfoTable[scope.$index][xindex])}"
                class="top-info"
                v-html="topInfoTable[scope.$index][xindex].P"></span>
          <input :ref="('f'+xindex+''+scope.$index)" :readonly="readonly" v-model="scope.row[xindex].P" :class="showtopcolor?'showtopColorInput':''"
                 :title="'S：'+scope.row[xindex].Y.toFixed(2)+' ， C：'+scope.row[xindex].X.toFixed(2)"
                 onfocus="this.select()" @change="inputChange(scope.row[xindex])"
                 @keyup.enter.stop="opKeyEnter($event,xindex,scope.$index)"
                 @keyup.up.stop="opKeyUp($event,xindex,scope.$index)"
                 @keyup.down.stop="opKeyDown($event,xindex,scope.$index)"
                 @keyup.left.stop="opKeyLeft($event,xindex,scope.$index)"
                 @keyup.right.stop="opKeyRight($event,xindex,scope.$index)"/>
        </template>
      </el-table-column>
    </el-table>
    <span v-if="userHtml" v-html="twodimenhtml"></span>
  </div>
</template>
<script>
  import {getGoodsTree} from '@/api/set/jxcgooddetail';
  import {saveData, getDetail, getControlData} from '@/api/set/goodsprice';

  export default {
    name: "DataContactEdit",
    data() {
      return {
        defaultValue: "",
        fixed: true,
        showtopcolor:false,
        twodimenhtml: "",
        userHtml: false,
        zhujing: [],
        qiujing: [],
        book: {
          XStart: "",
          XEnd: "",
          XSpace: "",
          YStart: "",
          YEnd: "",
          YSpace: "",
          BookContent: []
        },
        placeHolderContent: [],//格式等同于book.BookContent, 也可以是一个字符串
        form: {  //表单数据

        },
        formLabelWidth: '120px',
        topInfoData: [],//传递的顶部分栏信息，例如库存， 格式 [{"X":1.5,"Y":3,"P":8},{}]
        topInfoTable: [],//格式和 erweitable一样，为了加载速度快，所以这样写，不能直接绑定方法写，会卡死。
        rules: {////////定义正则验证字段。

        },
      }
    },
    props: {
      needSetDisabled: {//是否需要设置某些单元格禁用，默认true。
        default: true
      },
      needSetUnion: {//是否根据联合光度和是否启用柱镜0.25禁用设置某些单元格禁用，默认false。在needSetDisabled=true时有效
        default: false
      },
      erweitable: {
        type: Array,
        default: () => []
      },
      tdwidth: {
        default: 40
      },
      cutHeight: {
        default: 245
      },
      needSetHeight: {
        default: true
      },
      readonly: {
        default: false
      },
      cannotempty: {//不能为空，当填写空时，自动变成0   2018-10-17
        default: false
      },
      isShowTotalNumber: {//是否显示总数，价格设置、最大最小库存设置时需要设置成false
        default: true
      },
      precision: {//精度
        default: 'none' //默认不考虑精度问题。 如果设置，则四舍五入，使用Math.round,不能使用toFixed
      },
      isshowprice: {//是否显示价格
        default: false
      },
      enablenegative: {//禁用负数
        default: false
      },
      isMakeInvent: {
        default: false
      },
      fixinit:{
        default:false,
      },
      usermax:{
        default:false,
      },
      price: {}
    },
    methods: {
      opKeyUp(event, x, y) {
        if (this.$refs["f" + x + "" + (y - 1)])
          if (this.$refs["f" + x + "" + (y - 1)][0].parentNode.parentNode.className.indexOf("twodimensionaldisabled") > -1) {
            this.opKeyUp(event, x, y - 1)
            return
          } else {
            this.$refs["f" + x + "" + (y - 1)][0].focus()
          }
        else
          event.target.blur()
      },
      opKeyDown(event, x, y) {
        if (this.$refs["f" + x + "" + (y + 1)]) {
          if (this.$refs["f" + x + "" + (y + 1)][0].parentNode.parentNode.className.indexOf("twodimensionaldisabled") > -1) {
            this.opKeyDown(event, x, y + 1)
            return
          } else {
            this.$refs["f" + x + "" + (y + 1)][0].focus()
          }
        } else {
          event.target.blur()
        }
      },
      opKeyLeft(event, x, y) {
        if (this.$refs["f" + (x - 1) + "" + y]) {
          if (this.$refs["f" + (x - 1) + "" + y][0].parentNode.parentNode.className.indexOf("twodimensionaldisabled") > -1) {
            this.opKeyLeft(event, x - 1, y)
            return
          } else {
            this.$refs["f" + (x - 1) + "" + y][0].focus()
          }
        }
        else if (this.$refs["f" + (this.zhujing.length - 1) + "" + (y - 1)]) {
          if (this.$refs["f" + (this.zhujing.length - 1) + "" + (y - 1)][0].parentNode.parentNode.className.indexOf("twodimensionaldisabled") > -1) {
            this.opKeyLeft(event, this.zhujing.length - 1, y - 1)
            return
          } else {
            this.$refs["f" + (this.zhujing.length - 1) + "" + (y - 1)][0].focus()
          }
        }
        else
          event.target.blur()
      },
      opKeyRight(event, x, y) {
        if (this.$refs["f" + (x + 1) + "" + y]) {
          if (this.$refs["f" + (x + 1) + "" + y][0].parentNode.parentNode.className.indexOf("twodimensionaldisabled") > -1) {
            this.opKeyRight(event, x + 1, y)
            return
          } else {
            this.$refs["f" + (x + 1) + "" + y][0].focus()
          }
        }
        else if (this.$refs["f0" + (y + 1)]) {
          if (this.$refs["f0" + (y + 1)][0].parentNode.parentNode.className.indexOf("twodimensionaldisabled") > -1) {
            this.opKeyRight(event, 0, y + 1)
            return
          } else {
            this.$refs["f0" + (y + 1)][0].focus()
          }
        }
        else
          event.target.blur()
      },
      opKeyEnter(event, x, y) {//触发enter事件
        this.opKeyRight(event, x, y)
      },
      inputChange(item) {//2018-10-17
        if (this.cannotempty && item.P == "") {
          item.P = 0
        } else if (this.precision != 'none' && this.precision >= 0) {
          item.P = (Math.round(parseFloat(item.P || 0) * Math.pow(10, this.precision || 0)) / Math.pow(10, this.precision || 0)).toFixed(this.precision || 0)
        }
        if(this.enablenegative&&item.P<0){
          item.P=-item.P;
        }
        this.$emit("afterChange", item)
      },
      //获取顶部的背景色
      getTopInfoColor(theP, store) {
        if (this.usermax && parseFloat(store.maxstore || 0) == 0 && parseFloat(store.P || 0) == 0) {//未设置最大库存
          return '#E4E7ED';
        }
        if(this.isMakeInvent) {
          if (parseFloat(theP || 0) > parseFloat(store.P || 0)) {//增加
            return "#67C23A";
          } else if (parseFloat(theP || 0) == parseFloat(store.P || 0)) {
            return "#409EFF";
          } else {
            return "#E6A23C";
          }
        }
        return parseFloat(theP || 0) > parseFloat(store.P || 0) ? "orangered" : "#8CB803"
      },
      getDisabled(item) {//判断某项数据是否启用
        if (!this.needSetDisabled) {
          return false
        }
        // if (this.needSetUnion) {//联合光度
        if ((this.book.DisabledX25 && Math.abs(item.X) == 0.25) || (this.book.DisabledY25 && Math.abs(item.Y) == 0.25)) {
          item.P = ""
          return true
        }
        if (this.book.Union) {
          if (item.Y < 0 && Math.abs(item.Y) + Math.abs(item.X) > Math.abs(this.book.Union)) {
            item.P = ""
            return true
          }
        }

        if (this.book.BookContent.length > 0) {
          let temp1 = this.book.BookContent.filter(item1 => {
            return item1.X == item.X && item1.Y == item.Y
          })
          if (temp1.length == 0) {
            return true;
          }
        }
        return false
        // } else {

        //   return result
        // }
      },
      renderYdataWithInitData(i, initdata) {
        this.qiujing.push(i)
        let arr = []
        for (let j in this.zhujing) {
          var temp = initdata.filter((item) => {
            return item.X == this.zhujing[j] && item.Y == i;
          })
          if (this.fixinit && this.defaultValue && temp.length == 0) {
            temp.push({P: this.defaultValue});
          }
          arr.push({P: temp.length > 0 ? temp[0].P : this.cannotempty ? 0 : "", X: this.zhujing[j], Y: i})
        }
        this.erweitable.push(arr)
      },
      renderYdata(i) {
        this.qiujing.push(i)
        let arr = []
        for (let j in this.zhujing) {
          arr.push({P: this.defaultValue, X: this.zhujing[j], Y: i})
        }
        this.erweitable.push(arr)
      },
      cellClassName(data) {
        if (data.columnIndex == 0)
          return 'twodimensionalcellheader';
        if (this.getDisabled(data.row[data.columnIndex - 1]))
          return 'twodimensionalcelltd1 twodimensionaldisabled';//不允许填写
        else
          return 'twodimensionalcelltd1';
      },
      getExcel(title) {
        let header1 = ["球\\柱"]
        let column1 = [ "Y"]

        for(let i in this.zhujing){
          var name=this.getXYString(this.zhujing[i]);
          header1.push(name);
          column1.push(name);
        }
        var datas=[];
        for(let i in this.erweitable) {
          var row = this.erweitable[i];
          var newRow = {};
          for (let j in row) {
            if (j == 0)
              newRow.Y = this.getXYString(row[j].Y);
            newRow[this.getXYString(row[j].X)] = row[j].P ? row[j].P : '';
          }
          datas.push(newRow);
        }
        var biaoti = []
        this.$exportExcel(header1, column1, datas, title, biaoti);
      },
      getXYString(value){
        return (parseFloat(value)>0?"+":"")+parseFloat(value).toFixed(2);
      },
      createbook(initdata) {
        //生成柱镜
        this.zhujing = []
        this.qiujing = []
        this.erweitable.splice(0, this.erweitable.length)
        if (this.book.XSpace <= 0 || this.book.YSpace <= 0) {//防止死循环
          this.$message({
            showClose: true,
            message: '光度间隔必须大于0',
            type: 'error'
          });
          return
        }
        if (this.book.XStart >= this.book.XEnd) {
          for (let i = this.book.XStart; i >= this.book.XEnd; i -= this.book.XSpace) {
            this.zhujing.push(i)
          }
        } else {
          for (let i = this.book.XStart; i <= this.book.XEnd; i += this.book.XSpace) {
            this.zhujing.push(i)
          }
        }
        this.fixed = this.zhujing.length > 10;

        if (initdata && initdata.length > 0) {
          if (this.book.YStart >= this.book.YEnd) {
            for (let i = this.book.YStart; i >= this.book.YEnd; i -= this.book.YSpace) {
              this.renderYdataWithInitData(i, initdata)
            }
          } else {
            for (let i = this.book.YStart; i <= this.book.YEnd; i += this.book.YSpace) {
              this.renderYdataWithInitData(i, initdata)
            }
          }
        } else {
          if (this.book.YStart >= this.book.YEnd) {
            for (let i = this.book.YStart; i >= this.book.YEnd; i -= this.book.YSpace) {
              this.renderYdata(i)
            }
          } else {
            for (let i = this.book.YStart; i <= this.book.YEnd; i += this.book.YSpace) {
              this.renderYdata(i)
            }
          }
        }

        //设置顶部的显示信息
        this.showtopcolor=false;
        if (this.topInfoData && this.topInfoData.length > 0) {
          this.topInfoTable = this.erweitable.map(o => o.map(o2 => {
            let temp = Object.assign({}, o2)
            for (let i in this.topInfoData) {
              if (this.topInfoData[i].X == o2.X && this.topInfoData[i].Y == o2.Y) {
                temp.P = this.topInfoData[i].P
                temp.maxstore = this.topInfoData[i].maxstore
                temp.usermax = this.topInfoData[i].usermax
                return temp
              }
            }
            temp.P = 0
            return temp
          }))
          this.showtopcolor=this.topInfoTable.length>0;
        } else {
          this.topInfoTable = []
        }


      },
      geterwtableHeight() {
        if (!this.needSetHeight) {
          return null
        }
        return this.dialogtableHeight(this.cutHeight);
      },
      //第一个参数表示初始化球镜柱镜范围等设置，第二个参数表示初始化二维表值（编辑时使用）,第三个参数表示每个单元格顶部显示的内容，例如当前库存信息， 第四个参数表示默认值,第四个参数表示给单元格设置的placeholder。
      initBook(initbook, bookContent, defaultValue, topInfoData, placeHolderContent) {
        this.userHtml = false;
        if (typeof (initbook) == "undefined" || typeof(initbook.XStart) == "undefined") {
          this.initForm()
          return
        }
        this.defaultValue = defaultValue
        this.erweitable.splice(0, this.erweitable.length)
        if (initbook) {
          this.book = initbook
          if (typeof (this.book.BookContent) == "undefined" || this.book.BookContent == "") {
            this.book.BookContent = []
          }
          this.topInfoData = topInfoData
          this.placeHolderContent = placeHolderContent  //可以是字符串，也可以是数组
          // 其中的initbook.BookContent 仅仅是为了后面判断某单元格是否只读使用。真正的赋值还是要在保存时从二维表获取。
          this.createbook(bookContent)
        }

      },
      getzhujing() {
        return this.zhujing;
      },
      getqiujing() {
        return this.qiujing;
      },
      //简化显示内容 initbook=XY的范围  bookContent=最终的内容
      initBookFix(bookContent) {
        this.userHtml = true;
        this.erweitable.splice(0, this.erweitable.length)
        //生成柱镜
        this.zhujing = []
        //生成球镜
        this.qiujing = []

        var qiujingArea = []
        for (var bookC in bookContent) {
          var XV = Number(bookContent[bookC].X);
          bookContent[bookC].X = XV;
          var YV = Number(bookContent[bookC].Y);
          bookContent[bookC].Y = YV;
          var temp = this.zhujing.filter((item) => {
            return item == XV;
          })
          if (temp.length == 0)
            this.zhujing.push(XV)

          temp = qiujingArea.filter((item) => {
            return item == YV;
          })
          if (temp.length == 0)
            qiujingArea.push(YV)
        }

        this.zhujing.sort(this.sequence);
        qiujingArea.sort(this.sequence);

        for (var i in qiujingArea) {
          this.renderYdataWithInitData(qiujingArea[i], bookContent)
        }

        var topleft = "border-top:1px solid #000000;border-left:1px solid #000000;";
        var right = "border-right:1px solid #000000;";
        var bottom = "border-bottom:1px solid #000000;";

        //拼接HTML
        var HTML = "<table style='border-spacing:0px;text-align: center;line-height:28px'><tr><td style='width:48px;" + topleft + "'>球\\柱</td>";
        for (var i = 0; i < this.zhujing.length; i++) {
          HTML += "<td style='width:40px;" + topleft + "'>" + (this.zhujing[i] > 0 ? "+" : "") + (this.zhujing[i].toFixed(2)) + "</td>";
        }
        HTML += "<td style='width:40px;" + topleft + right + "'>合计</td>";
        HTML += "</tr>";


        var qiuNum = []
        for (var j = 0; j < this.qiujing.length; j++) {
          HTML += "<tr><td style='" + topleft + "'>" + (this.qiujing[j] > 0 ? "+" : "") + (this.qiujing[j].toFixed(2)) + "</td>";

          var totalNum = 0;
          for (var i = 0; i < this.zhujing.length; i++) {
            var zjNUM = this.erweitable[j][i].P ? parseInt(this.erweitable[j][i].P) : 0;
            totalNum += zjNUM;
            HTML += "<td style='" + topleft + "'>" + (this.erweitable[j][i].P) + "</td>";
            if (j == 0) {
              qiuNum.push(zjNUM);
            } else {
              qiuNum[i] = qiuNum[i] + zjNUM;
            }
          }
          HTML += "<td style='" + topleft + right + "'>" + totalNum + "</td>";
          HTML += "</tr>";
        }

        HTML += "<tr><td style='width:48px;" + topleft + bottom + "'>合计</td>";
        for (var i = 0; i < qiuNum.length; i++) {
          HTML += "<td style='width:40px;" + topleft + bottom + "'>" + qiuNum[i] + "</td>";
        }
        HTML += "<td style='width:40px;" + topleft + bottom + right + "'>" + this.totalnumber + "</td>";
        HTML += "</tr></table>";

        this.twodimenhtml = HTML;
      },
      sequence(a, b) {//从大到小排列
        if (a > b) {
          return -1;
        } else if (a < b) {
          return 1
        } else {
          return 0;
        }
      },
      initForm() {
        this.qiujing = []
        this.zhujing = []
        this.erweitable.splice(0, this.erweitable.length)
        this.topInfoData = []
        this.showtopcolor=false;
        this.topInfoTable = []
        this.defaultValue = ""
      }
    },
    computed: {
      totalnumber() {
        let s = 0;
        this.erweitable.forEach(o => {
          o.forEach(o2 => {
            if (o2.P)
              s += parseFloat(o2.P)
          })
        })
        this.$emit("num", s)
        return s
      }
    },
    mounted() {

    },
    components: {},
  }
</script>

<style scoped>
  .erweitable td {
    border: 1px solid #000000;
    min-width: 50px;
    max-width: 100px;
    text-align: center;
    vertical-align: center;
  }

  .erweitable .content {
    border: none;
    padding: 1px;
  }

  .top-info {
    font-size: 12px;
    display: inline-block;
    width: 100%;
    text-align: center;
    line-height: 12px;
    height: 12px;
    float: left;
  }
</style>

<style>
  .twodimensionalcelltd1 {
    border: 1px solid #000000; /*边框颜色*/
    padding: 1px 0 !important;
    font-weight: normal;
  }

  .twodimensionaldisabled {
    background-color: #e9e9e9;
  }

  .twodimensionaldisabled input {
    display: none;
  }

  .twodimensionaldisabled .top-info {
    display: none;
  }

  .twodimensionalcelltd1 input {
    width: 94%;
    border: 0px;
    text-align: center;
    height: 23px;
    font-size: 12px;
    font-weight: normal;
    background-color: transparent;
  }

  .twodimensionalcellheader {
    border: 1px solid #000000; /*边框颜色*/
    background-color: #fffdef !important;
    padding: 3px 0 !important;
    font-weight: normal;
    font-size: 12px;
  }

  .twodimensionalcelltd1 .cell, .twodimensionalcellheader .cell {
    padding-left: 3px !important;
    padding-right: 3px !important;
  }

  .showtopColorInput {
    font-weight: bolder !important;
    font-size: 14px !important;
  }

  .el-table__body-wrapper {
    overflow: auto !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/set/goodsprice/TwoDimensionalTable.vue